import Auth from '../../services/auth'
import * as types from '../mutationTypes'
import router from '../../routes/router'

let state = {
  isLoggedIn: false,
  accessToken: null,
  loading: false,
  error: null
}

const getters = {
  isAuthorized (state) {
    return state.isLoggedIn
  },
  token (state) {
    return state.accessToken
  },
  error (state) {
    return state.error
  }
}

const actions = {
  async login ({ commit, dispatch }, data) {
    const searchData = {
      searchGeneral: null,
      searchISD: null,
      searchStatus: null,
      searchRegion: [],
      searchCrewLead: null,
      searchFlagged: null,
      searchLabel: null,
      searchCheckedValue: null,
      searchWorkOrders: null,
      searchFCMP: [],
      searchDCMP: [],
      searchCPA: null,
      searchStartDate:  null,
      searchReturn: null,
      searchSubForeman: null
    }
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      commit(types.REQUEST_AUTHENTICATION)
      let res = await Auth.login(data)
      if (res.status === 200) {
        commit(types.RECEIVE_AUTHENTICATION_SUCCESS, res.data)
        dispatch('user/setCurrentUser', res.data, { root: true })
        if (res.data.roles[0] === 'Worker' || res.data.roles[0] === 'Sub Foreman') {
          // TODO: why dispatch call for unscheduled would not work in here

          searchData.searchSubForeman = res.data.id
          dispatch('workOrderTask/getTasks', searchData, { root: true })
          router.push('/calendar')
        } else {

          dispatch('workOrderTask/getTasks', searchData, { root: true })
          router.push('/work-orders')
        }
      }
    } catch (err) {
      commit(types.RECEIVE_AUTHENTICATION_ERROR, { error: 'Error Logging In, Please Try Again.' })
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async sessionCheck ({ commit, dispatch }) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      await Auth.sessionCheck()
    } catch (e) {
      dispatch('logout')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  clearAuth ({ commit }) {
    commit(types.CLEAR_AUTH_ERROR)
  },
  logout ({ commit, dispatch }) {
    commit(types.CLEAR_AUTHENTICATION)
    dispatch('workOrderTask/clearTasks', null, { root: true })
    dispatch('user/clear', null, { root: true })
    router.push('/')
  }
}

// mutations
const mutations = {
  [types.REQUEST_AUTHENTICATION] (state) {
    state.accessToken = null
    state.isLoggedIn = false
    state.loading = true
    state.error = ''
  },
  [types.RECEIVE_AUTHENTICATION_SUCCESS] (state, data) {
    state.accessToken = data.accessToken
    state.isLoggedIn = true
    state.loading = false
    state.error = null
  },
  [types.RECEIVE_AUTHENTICATION_ERROR] (state, data) {
    state.accessToken = null
    state.isLoggedIn = false
    state.loading = false
    state.error = data.error
  },
  [types.CLEAR_AUTHENTICATION] (state) {
    state.accessToken = null
    state.isLoggedIn = false
    state.loading = false
    state.error = null
  },

  [types.CLEAR_AUTH_ERROR] (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
